import React, {useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import aboutSection from '../../../assests/service.png'
import {
  FaQuestionCircle,
  FaBriefcase,
  FaPhoneAlt,
  FaTheaterMasks,
  FaRegStar,
  FaUsers,
} from "react-icons/fa";
import { Helmet } from "react-helmet-async";
const items = [
  {
    icon: <FaQuestionCircle size={40} color="#09588D" />,
    title: "ABOUT TEKIT",
    description: "The more you know, the more you grow.",
    route: "/about-tekit",
  },
  {
    icon: <FaBriefcase size={40} color="#09588D" />,
    title: "CAREERS",
    description: "Join us and build an exciting future.",
    route: "/careers",
  },
  {
    icon: <FaTheaterMasks size={40} color="#09588D" />,
    title: "OUR CULTURE",
    description: "A workplace where creativity thrives.",
    route: "/culture",
  },
  {
    icon: <FaRegStar size={40} color="#09588D" />,
    title: "OUR JOURNEY",
    description: "Hear what our clients have to say.",
    route: "/tekit-journey",
  },
  {
    icon: <FaUsers size={40} color="#09588D" />,
    title: "OUR TEAM",
    description: "Meet the faces behind our success.",
    route: "/our-team",
  },
];

const AboutUs = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
     <Helmet>
        <title>Top #1  IT Solutions Company | IT Staffing Services - TekIT</title>
           <meta name="description" content="Accelerate your business growth with our IT services. From software development to digital solutions, we deliver customized, reliable, and on-time results.." />
        <meta name="keywords" content="Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services
" />
      
        <link rel="canonical" href="https://www.tekitsolution.com/about-us" />
      </Helmet>
    <div className="py-16 pt-40 bg-[#f4f5f6] bg-cover bg-center bg-no-repeat "
    style={{ backgroundImage: `url(${aboutSection})` }}
    >
      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-10">
        {items.map((item, idx) => (
          <div
            key={idx}
            onClick={() => navigate(item.route)}
            className="group relative rounded-xl p-5 cursor-pointer transition-all duration-300"
          >
            <div className="flex items-center gap-3">
              <div className="text-red-500 bg-[#ececec] group-hover:bg-white p-2 rounded-md shadow-sm transition-colors duration-300  ">
                {item.icon}
              </div>
              <h3 className="font-bold text-gray-800 2xl:text-[26px] lg:text-[22px] text-[42px] font-recoleta  hover:translate-y-0 hover:opacity-100 transition-all">{item.title}</h3>
            </div>

            <div className="overflow-hidden mt-0 lg:block hidden" >
              <div className="transform translate-y-8 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500 ease-out -mt-1 px-16">
                <p className="text-gray-500 text-[14px] 2xl:text-20 lg:text-[18px] mb-2 font-recoleta">{item.description}</p>
                <button

                  className="text-[#F86F4B] text-sm font-semibold flex items-center gap-1 font-recoleta"
                >
                  Know More <span className="text-lg">―</span>
                </button>
              </div>
            </div>
            <div className=" mt-0 block lg:hidden lg:ml-8">
              <div className=" -mt-1 px-16">
                <p className="text-gray-500  text-[38px] mb-2 font-recoleta">{item.description}</p>
                <button
                  onClick={() => navigate(item.route)}
                  className="text-[#F86F4B] text-[32px] font-semibold flex items-center gap-1 font-recoleta"
                >
                  Know More <span className="text-[32px]">―</span>
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

    </div></>
  );
};

export default AboutUs;